export default __webpack_public_path__ + "static/media/number2.1a7b1c8e.png";